import { Component, Inject, HostListener, AfterViewInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

declare var google: any;
declare const ApplePaySession: any;

@Component({
    selector: 'app-cardpoint-pay-dialog',
    templateUrl: './cardpoint-pay-dialog.component.html',
    styleUrls: ['./cardpoint-pay-dialog.component.scss'],
    standalone: false
})
export class CardpointPayDialogComponent implements AfterViewInit {

	trustedIframeUrl: SafeResourceUrl;
	accountSetup: any;

	log = signal([]);
	error = signal(null);
	hasDigitalWallet = signal(false);
	isDevelopment = signal(false);

	@HostListener('window:message', ['$event'])
	onMessage(e) {
		try {
			let token = JSON.parse(e.data);
			this.data.token = token;
			console.log(token);
		} catch (e) {

		}
	}

	constructor(
		private sanitizer: DomSanitizer,
		public http: HttpClient,
		public appService: AppService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<CardpointPayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.isDevelopment.set(!environment.production);
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.redirectURL);
		this.accountSetup = this.data.accountSetup;
	}

	async ngAfterViewInit(): Promise<void> {
		console.log('this.accountSetup', this.accountSetup);
		if (this.accountSetup?.clientConfiguration?.googlePay) {
			this.hasDigitalWallet.set(true);
			this.initGooglePay(this.accountSetup.clientConfiguration.googlePay);
		}
		if (this.accountSetup?.clientConfiguration?.applePay) 	this.initApplePay(this.accountSetup.clientConfiguration.applePay);
	}

	applyTimer: any;
	applyCardPoint() {
		clearTimeout(this.applyTimer);
		this.error.set(null);
		this.applyTimer = setTimeout(() => {
			let token = this.data.token;
			if (!token) return;
			if (token.validationError) {
				this.appService.alert({ "content": token.validationError });
			}
			if (token.message.length) {
				this.dialogRef.close({ mode: "success", data: { token: token.message, expirey: token.expiry, expiry: token.expiry } });
			}
		}, 1500);
	}

	onFrameLoaded(ev) { }

	// ========================================================================>
	// google pay
	// ========================================================================>

	initGooglePay(clientConfiguration) {
		let that = this;
		const merchantInfo = {
			merchantId: clientConfiguration.merchantId,
			merchantName: clientConfiguration.merchantName
		};
		const baseGooglePayRequest = {
			apiVersion: 2,
			apiVersionMinor: 0,
			allowedPaymentMethods: [
				{
					type: 'CARD',
					parameters: {
						allowedAuthMethods: clientConfiguration.allowedCardAuthMethods,
						allowedCardNetworks: clientConfiguration.allowedCardNetworks
					},
					tokenizationSpecification: {
						type: 'PAYMENT_GATEWAY',
						parameters: {
							'gateway': clientConfiguration.gateway,
							'gatewayMerchantId': clientConfiguration.gatewayMerchantId
						}
					}
				}
			],
			merchantInfo
		};

		Object.freeze(baseGooglePayRequest);
		let paymentsClient = null;

		getGooglePaymentsClient().isReadyToPay(baseGooglePayRequest).then(function(res) {
			if (res.result) {
				const button = getGooglePaymentsClient().createButton({
					buttonColor: 'black',
					buttonType: 'pay',
					buttonRadius: 8,
					buttonBorderType: 'no_border',
					buttonSizeMode: 'fill',
					onClick: onGooglePaymentButtonClicked
				});
				document.getElementById("google-payment-container").appendChild(button);

			} else {
				console.log("Google Pay is not ready for this user.");
			}
		}).catch(console.error);

		function getGooglePaymentsClient() {
			if (paymentsClient === null) {
				paymentsClient = new google.payments.api.PaymentsClient({
					environment: that.isDevelopment() ? 'TEST' : 'PRODUCTION',
					merchantInfo,
				});
			}
			return paymentsClient;
		}

		async function onGooglePaymentButtonClicked() {
			const req = {
				...baseGooglePayRequest,
				transactionInfo: {
					countryCode: 'US',
					currencyCode: 'USD',
					totalPriceStatus: 'FINAL',
					totalPrice: that.data.total.toFixed(2),
				},
			};
			let googleResponse;
			try {
				googleResponse = await getGooglePaymentsClient().loadPaymentData(req);
			} catch (e) {
				console.error('error getting google response ',e);
			}

			if (!googleResponse?.paymentMethodData?.tokenizationData?.token) return;

			const payload = {
				digitalWallet: {
					payload: {
						encryptionhandler: 'EC_GOOGLE_PAY',
						devicedata: googleResponse.paymentMethodData.tokenizationData.token,
					},
				},
			};
			await that.tokenizePaymentRequest(clientConfiguration, payload);

		}
	}

	// ========================================================================>
	// apple pay
	// ========================================================================>

	appleClientConfiguration;
	appleClientSetup;
	initApplePay(clientConfiguration) {
		this.appleClientSetup = clientConfiguration;
		this.appleClientConfiguration = {
            tokenizationUrl: clientConfiguration.tokenizationUrl,
			countryCode: 'US',
			currencyCode: 'USD',
			merchantCapabilities: clientConfiguration.merchantCapabilities,
			supportedNetworks: clientConfiguration.supportedNetworks,
			total: {
				label: clientConfiguration.merchantName,
				type: 'final',
				amount: this.data.total,
			},
		};
		const payButton = document.createElement('apple-pay-button');
		payButton.setAttribute('buttonstyle', 'white-outline');
		payButton.setAttribute('type', 'plain');
		payButton.setAttribute('locale', 'en-US');
		payButton.addEventListener('click', this.initApplePaymentRequest.bind(this));
		document.getElementById("apple-payment-container").appendChild(payButton);

	}

	async initApplePaymentRequest() {
		this.generateApplePaymentRequest().then((token) => {

		}).catch(err => {
			this.error.set(this.appService.serializeError(err));
		});
	}

	async generateApplePaymentRequest() {
		let that = this;
		const session = new ApplePaySession(3, this.appleClientConfiguration);
		session.onvalidatemerchant = (event) => {
			// Send validation URL to your backend
			const payload = {
				applePayMerchantId: this.appleClientSetup.merchantId,
				merchantName: this.appleClientSetup.merchantName,
                domainName: window.location.host || window.location.hostname,
			}
			this.upadateLog(JSON.stringify(this.appleClientSetup));
			this.upadateLog([JSON.stringify(payload)]);
			fetch(`${this.appService.appConfig.tabitBridge}/apple-pay/validate`, { // Bridge API - TBD
				method: 'POST',
				body: JSON.stringify(payload),
				headers: { 'Content-Type': 'application/json'},
			}).then(response => response.json())
			.then(merchantSession => {
				if (merchantSession?.error) {
					this.error.set(merchantSession?.error);
				}
				this.upadateLog([JSON.stringify(merchantSession)]);
				session.completeMerchantValidation(merchantSession);
			}).catch(err => {
				this.error.set(this.appService.serializeError(err));
			});
		};
		session.onpaymentauthorized = (event) => {
			if (event?.payment?.token) {
				session.completePayment(ApplePaySession.STATUS_SUCCESS);

				const paymentToken = event.payment.token;
				const paymentData = paymentToken.paymentData;

				const deviceDataParts = [
					paymentData.data,
					'ectype=apple',
					`ecsig=${paymentData.signature}`,
					`eckey=${paymentData.header.ephemeralPublicKey}`,
					`ectid=${paymentData.header.transactionId}`
				];

				// Add echash and ecpublickeyhash if publicKeyHash exists
				if (paymentData.header.publicKeyHash) {
					const echash = paymentData.header.applicationDataHash || '';
					deviceDataParts.push(`echash=${echash}`);
					deviceDataParts.push(`ecpublickeyhash=${paymentData.header.publicKeyHash}`);
				}

				const deviceData = deviceDataParts.join('&');

				const payload = {
					digitalWallet: {
						payload: {
							encryptionhandler: 'EC_APPLE_PAY',
							devicedata: deviceData,
						},
					},
				};
				return that.tokenizePaymentRequest(that.appleClientConfiguration, payload);

			} else {
				session.completePayment(ApplePaySession.STATUS_FAILURE);
				throw('Paymend not authorized');
			}
		};
		session.oncancel = (event) => {
			console.log('=== oncancel ===', event);
		};
		session.begin();
	}

	// ========================================================================>
	// tokenize
	// ========================================================================>

    async tokenizePaymentRequest(clientConfiguration, payload) {
        try {
            if (!clientConfiguration.tokenizationUrl) {
                clientConfiguration.tokenizationUrl = 'https://fts-uat.cardconnect.com/cardsecure/api/v1/ccn/tokenize';
            }

            const tokenizeResponse = await fetch(clientConfiguration.tokenizationUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(response => {
                console.log('tokenize response raw', response);
                return response.json();
            });

            console.log('tokenize response json', tokenizeResponse);

            this.dialogRef.close({
                mode: 'success',
                data: {
                    // verify the exact field name from API, often it's outputToken or token
                    token: tokenizeResponse.token || tokenizeResponse.outputToken
                }
            });

        } catch (e) {
            console.error('tokenize error ', e);
        }
    }


	upadateLog(_val) {
		this.log.update(val => val.concat([_val]))
	}

}
